import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EapComponent } from './eap/eap.component';
import { GrantsComponent } from './grants/grants.component';
import { IstComponent } from './ist/ist.component';
import { UmComponent } from './um/um.component';
import { AdministrationComponent } from './administration/administration.component';
import { NotificationStoreComponent } from './administration/notification-store/notification-store.component';
import { ForgotPasswordComponent } from './common/forgot-password/forgot-password.component';
import { LoginComponent } from './common/login/login.component';
import { EapApplicationsComponent } from './eap/eap-applications/eap-applications.component';
import { EapMyApplicationsComponent } from './eap/eap-my-applications/eap-my-applications.component';
import { GrantsApplicationExtComponent } from './grants/grants-application-ext/grants-application-ext.component';
import { GrantsApplicationsComponent } from './grants/grants-applications/grants-applications.component';
import { GrantsMyApplicationsComponent } from './grants/grants-my-applications/grants-my-applications.component';
import { HomeComponent } from './home/home.component';
import { IstApplicationExtComponent } from './ist/ist-application-ext/ist-application-ext.component';
import { IstApplicationsComponent } from './ist/ist-applications/ist-applications.component';
import { IstMyApplicationsComponent } from './ist/ist-my-applications/ist-my-applications.component';
import { ChangePasswordComponent } from './personalization/change-password/change-password.component';
import { ChangeThemeComponent } from './personalization/change-theme/change-theme.component';
import { PersonalizationComponent } from './personalization/personalization.component';
import { ViewProfileComponent } from './personalization/view-profile/view-profile.component';
import { AuthGuard } from './services/auth.guard';
import { AnalyticshomeComponent } from './analytics/analyticshome.component';
import { ApplicationViewComponent } from './common/application-view/application-view.component';
import { ExpandEmailComponent } from './common/correspondence/expand-email/expand-email.component';
import { FilePreviewComponent } from './common/document-summary/file-preview/file-preview.component';
import { ErrorPageComponent } from './common/error-page/error-page.component';
import { EapApplicationExtComponent } from './eap/eap-application-ext/eap-application-ext.component';
import { EapApplicationsResolve } from './eap/eap-applications/eap-applications.resolve';
import { EapMyApplicationsResolve } from './eap/eap-my-applications/eap-my-applications.resolve';
import { GrantsApplicationsResolve } from './grants/grants-applications/grants-applications.resolve';
import { GrantsMyApplicationsResolve } from './grants/grants-my-applications/grants-my-applications.resolve';
import { IstApplicationsResolve } from './ist/ist-applications/ist-applications.resolve';
import { IstMyApplicationsResolve } from './ist/ist-my-applications/ist-my-applications.resolve';

const routes: Routes = [
  {
    path: 'home', component: HomeComponent, data: { breadcrumb: 'Home' },
    canActivate: [AuthGuard],
    children: [

      // IST
      {
        path: 'ist', component: IstComponent, data: { breadcrumb: 'IST Dashboard' },
        children: [

          {
            path: 'applications',
            component: IstApplicationsComponent,
            resolve: { items: IstApplicationsResolve },
            data: { breadcrumb: 'All Applications' },
            children: [
              {
                path: 'application-ext/:id',
                component: IstApplicationExtComponent,
                data: { breadcrumb: 'Request' },
                loadChildren: () => import('./ist/ist-application-ext/IstApplicationExt-routing-module').then(m => m.IstApplicationExtModule)
              },
            ]
          },
          {
            path: 'my-applications',
            component: IstMyApplicationsComponent,
            resolve: { items: IstMyApplicationsResolve },
            data: { breadcrumb: 'My Applications' },
            children: [
              {
                path: 'application-ext/:id',
                component: IstApplicationExtComponent,
                data: { breadcrumb: 'Request' },
                loadChildren: () => import('./ist/ist-application-ext/IstApplicationExt-routing-module').then(m => m.IstApplicationExtModule)
              },
            ]
          },
        ]
      },

      // GRANTS
      {
        path: 'grants', component: GrantsComponent, data: { breadcrumb: 'Grants Dashboard' },
        children: [
          {
            path: 'applications',
            component: GrantsApplicationsComponent,
            resolve: { items: GrantsApplicationsResolve },
            data: { breadcrumb: 'All Applications' },
            children: [
              {
                path: 'application-ext/:id',
                component: GrantsApplicationExtComponent,
                data: { breadcrumb: 'Request' },
                loadChildren: () => import('./grants/grants-application-ext/grants-application-ext.routing.module').then(m => m.GrantsApplicationExtModule)
              },
            ]

          },
          {
            path: 'my-applications',
            component: GrantsMyApplicationsComponent,
            resolve: { items: GrantsMyApplicationsResolve },
            data: { breadcrumb: 'My Applications' },
            children: [
              {
                path: 'application-ext/:id',
                component: GrantsApplicationExtComponent,
                data: { breadcrumb: 'Request' },
                loadChildren: () => import('./grants/grants-application-ext/grants-application-ext.routing.module').then(m => m.GrantsApplicationExtModule)
              },
            ]
          },
        ]
      },
      // EAP
      {
        path: 'eap', component: EapComponent, data: { breadcrumb: 'EAP Dashboard' },
        children: [
          {
            path: 'applications',
            component: EapApplicationsComponent,
            resolve: { items: EapApplicationsResolve },
            data: { breadcrumb: 'All Applications' },
            children: [
              {
                path: 'application-ext/:id',
                component: EapApplicationExtComponent,
                data: { breadcrumb: 'Request' },
                loadChildren: () => import('./eap/eap-application-ext/eap-application-ext.routing.module').then(m => m.EapApplicationExtModule)
              },
            ]
          },
          {
            path: 'my-applications',
            component: EapMyApplicationsComponent,
            resolve: { items: EapMyApplicationsResolve },
            data: { breadcrumb: 'My Applications' },
            children: [
              {
                path: 'application-ext/:id',
                component: EapApplicationExtComponent,
                data: { breadcrumb: 'Request' },
                loadChildren: () => import('./eap/eap-application-ext/eap-application-ext.routing.module').then(m => m.EapApplicationExtModule)
              },
            ]
          }
        ]
      },
      // UM
      {
        path: 'um', component: UmComponent, data: { breadcrumb: 'UM Dashboard' },
        loadChildren: () => import('./um/um.component.routing.module').then(m => m.UmModule)
      },
      // analytics
      {
        path: 'analytics', component: AnalyticshomeComponent, data: { breadcrumb: 'analytics' },
        loadChildren: () => import('./analytics/analyticshome.routing.module').then(m => m.AnalyticshomeModule)
      },

      // Dashboard
      {
        path: 'dashboard', component: UmComponent, data: { breadcrumb: 'UM Dashboard' },
        children: [
        
        ]
      },
      // Administration
      {
        path: 'administration', component: AdministrationComponent, data: { breadcrumb: 'Administration' },
        loadChildren: () => import('./administration/administration.routing.module').then(m => m.AdministrationModule)
      },

      // Personalization
      {
        path: 'personalization', component: PersonalizationComponent, data: { breadcrumb: 'Personalization' },
        children: [
          { path: 'changeTheme', component: ChangeThemeComponent, data: { breadcrumb: 'Change Theme' } },
          { path: 'changePassword', component: ChangePasswordComponent, data: { breadcrumb: 'Change Password' } },
          { path: 'viewProfile', component: ViewProfileComponent, data: { breadcrumb: 'View Profile' } }//,
          // { path: 'expandemail', component: ExpandEmailComponent, data: { breadcrumb: 'Expand Email' } },
        ]
      },

      // notifications store
      { path: 'notifications_store', component: NotificationStoreComponent, data: { breadcrumb: 'Notifications Store' } },
    ]
  },
  // other screens
  {
    path: 'expandemail', component: ExpandEmailComponent,
    data: { breadcrumb: 'Expand Email' },
    canActivate: [AuthGuard]
  },
  {
    path: 'filepreview/:fileid/:type/:filename', component: FilePreviewComponent,
    data: { breadcrumb: 'File preview' }

  },
  { path: ':code/login', component: LoginComponent, data: { breadcrumb: 'Login' } },
  { path: 'login', component: LoginComponent, data: { breadcrumb: 'Login' } },
  { path: 'forgot_password/:id', component: ForgotPasswordComponent, data: { breadcrumb: 'Forgot Password' } },
  { path: '404/:message', component: ErrorPageComponent, data: { breadcrumb: '404' } },
  { path: 'applicationview/:appid/:moduleid', component: ApplicationViewComponent, data: { breadcrumb: 'Application View' } },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: '**', component: ErrorPageComponent, data: { breadcrumb: '404' } }
];
const options = { relativeLinkResolution: 'legacy' }
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
